import {getLogger} from "@goodgamestudios/logger";
const logger = getLogger("CreateJs.ExternalInterface");

export class ExternalInterface {


    public static marshallExceptions = false;
    /* Fakes */
    private static _flashObject: HTMLObjectElement | undefined;

    /*Since we use in the GameCode the Game Canvas we´re relying on that this id will not change.*/
    private static _objectID = "flashObject";

    /**
     * ExternalInterface was a bridge between Flash and Javascript in the html page hosting the swf.
     * with HTML5 the game can always access function in the window.
     * ExternalInterface API is kept mostly to be able to communicate with the PARENT hosting page (ggs-integration-page)
     * thus availability is checking if window is the main one or not
     * @returns {boolean}
     */
    public static get available(): boolean {
        return window.parent != window.self;
    }

    public static get objectID(): string {
        return ExternalInterface._objectID;
    }

    public static setFlashObject(): void {
        logger.warn("WHERE / WHY ARE WE STILL SETTING THE FLASHOBJECT ??")
        ExternalInterface._flashObject = <HTMLObjectElement>document.getElementById("flashObject");
    }

    public static getFlashObject(): HTMLObjectElement {
        logger.warn("WHO is asking for getFlashObject??");
        return ExternalInterface._flashObject!;
    }

    public static addCallback(functionName: string, closure: (...args: any[]) => any): void {
        logger.debug("adding callback to ", functionName);
        if (functionName.length > 0 && closure !== undefined) {
            window.messageHandler.addEvent(functionName, closure);
        }
    }

    /**
     *
     * @param functionName  the function name to be invoked in the global scope [fire&forget - do not wait or expect anything back] OR a string representing a function to be immediately "eval-ed"
     * @param params   parameters to be passed to the function being applied.
     *          IF THERE IS A CALLBACK please use asyncCall ( and maybe switch to a Promise based handling)
     * @returns {any}  returns the result of the javascript function that was eval-ed  or nothing in case of fire&forget function call
     */
    public static call(functionName: string, ...params: any[]): any {
        //  INLINE FUNCTION : execute it directly
        if (!ExternalInterface.isNameOnly(functionName)) {
            if (params.length === 0) {
                return eval(`(${functionName})()`); // tslint:disable-line:no-eval
            }

            return eval(`(${functionName})(${params})`); // tslint:disable-line:no-eval
        }
        if ((params.length > 0 && typeof params[params.length - 1] === "function")) {
            logger.error("it seems a callback has been passed to ExternalInterface - please use ExternalInterface.asynCall  in order to be able to handle callbacks and promises - otherwise result might be unpredictable");
            return;
        }
        // a string pointing to a function with the same name, available in the html page (iframe)
        // REMEMBER! if you expect a value back or a callback to be triggered, use the asyncCall API.
        try {
            if (params.length === 0) {
                window.messageHandler.sendMessage(functionName);
            } else {
                window.messageHandler.sendMessage(functionName, ...params);
            }
        } catch (e) {
            logger.warn(`Something went wrong with ExternalInterface SYNC call ${functionName}:  ${e}`);
        }
    }


    /**
     *
     * @param functionName  the function name to be invoked in the global scope from which we expect a value back or after whose execution we want to trigger other actions
     * @param params   parameters to be passed to the function being applied.
     *          IF THERE IS A CALLBACK the callback will be wrapped into the waitForMessageDone callback
     *          the messagehandler will return a Promise so that gamecode can "then" to get the results of the called functions .
     * @returns Promise<any>  returns  a Promise that will be resolved when the MessageHandler replies with complete
     */
    public static asyncCall(functionName: string, ...params: any[]): Promise<any> {
        if (!ExternalInterface.available) {
            return Promise.reject("ExternalInterface not available");
        }
        // that's  the real async part where we communicate with the integration-page
        return new Promise((resolve, reject) => {
            try {
                const originalCallback = (params.length > 0 && typeof params[params.length - 1] === "function") ? params.pop() : null;
                // -- a callback is passed in the parameter.  let the MessageHandler deal with the "async phase" and execute the callback
                const waitForMessageDone = (returnedValue: any) => {
                    logger.debug(`Message ${functionName} went back and forth`, returnedValue);
                    if (originalCallback) {
                        originalCallback(returnedValue);
                    }
                    resolve(returnedValue);
                }
                params.push(waitForMessageDone);
                window.messageHandler.sendMessage(functionName, ...params);

            }
            catch (e) {
                reject(`Something went wrong with ExternalInterface ASYNC call ${functionName}:  ${e}`);
            }
        });
    }

    private static  isNameOnly(func: string): boolean {
        return func.search(/(\=\>\(|\)|\{|\})/i) === -1;
    }
}


/**
 *
 * MessageHandler takes care of the messages sent back and fort the games and the pages containing them (as iframes)
 * see https://source.services.ggs-net.com/red-applications/integrationpoc/merge_requests
 *
 * these are the functions that are available in the integration page and will be triggered by ExternalInterface
 * see https://source.services.ggs-net.com/red-applications/game-integration/blob/master/app/public/templates/shared/js/interface.js
 */

export interface MessageHandler {
    register(): any;

    addEvent(name: string, callback: Function): any;

    sendMessage(name: string, ...params: any[]): any;
}

declare global {
    interface Window {
        messageHandler: MessageHandler;
    }
}




